angular
  .module('app')
  .component('unsubscribeComponent', {
    templateUrl: 'app/components/unsubscribe/unsubscribe.tmpl.html',
    controller: function () {
      const self = this;
      self.success = true;
    }
  });
